import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SavingstransactionService } from "../../shared/savingstransaction.service";
import { PrintsavingstransactionlistserviceService } from "../../shared/print/printsavingstransactionlistservice.service";

@Component({
  selector: 'app-savingstransactionlist',
  templateUrl: './savingstransactionlist.component.html',
  styleUrls: ['./savingstransactionlist.component.css']
})
export class SavingstransactionlistComponent implements OnInit {

  private ToReceiptForm: boolean= false;

  displayedColumns: string[] = ['Receipt No', 'Date', 'Customer','DepositNo', 'Princ. Amount', 'Int. Amount', 'TotalAmount', 'New'];
  dataSource = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private savingstransactionService: SavingstransactionService,
     private printsavingstransactionlistserviceService: PrintsavingstransactionlistserviceService,
     private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.getSavingsReceiptList();
    this.dataSource.paginator = this.paginator;
  }

  
  getSavingsReceiptList() {
    this.savingstransactionService.FetchSavingsTransactionList()
      .toPromise()
      .then(data => {
        this.dataSource.data = data;
      })
      .catch(err => { console.log(err) });
  }

  New() {
    this.router.navigate(['/savingstransaction']);
  }

  Edit(savingsTransaction: any) {
    this.router.navigate(['/savingstransaction', savingsTransaction.Id]);
  }

  Print(txt: any, savings: any) {
    //this.paymentreceiptsService.GetSavingsCloseById(savings.Id);
    this.printsavingstransactionlistserviceService.GenerateReport(this.ToReceiptForm,savings.Id)
  }

  applyFilter(filterValue: string) {

    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }
}
